import { Link } from "react-router-dom";

function NotFound() {
  return (
    <section className="container d-flex flex-column vh-100">
      <div className="row align-items-center justify-content-center g-0 h-lg-100 py-10">
        <div className="offset-xl-1 col-xl-4 col-lg-6 col-md-12 col-12 text-center text-lg-start">
          <div className="d-flex flex-column gap-5">
            <div className="d-flex flex-column gap-3">
              <h1 className="display-1 mb-0">404</h1>
              <p className="mb-0 lead px-4 px-md-0">
                Oops! Sorry, we couldn’t find the page you were looking for. If
                you think this is a problem with us, please
                <a
                  href="https://acharyakulamranchi.com/contact"
                  target="_blank"
                  className="btn-link ms-2"
                >
                  Contact us
                </a>
              </p>
            </div>
            <div>
              <Link to="/" className="btn btn-primary me-2 px-8">
                Back to Safety
              </Link>
            </div>
          </div>
        </div>
        <div className="offset-xl-1 col-xl-6 col-lg-6 col-md-12 col-12 mt-8 mt-lg-0 d-flex justify-content-end">
          <img src="/assets/images/404.png" alt="error" className="w-75" />
        </div>
      </div>
    </section>
  );
}
export default NotFound;
